// // src/components/ReusableChart.jsx
// import React, { useState, useMemo } from "react";
// import {
//     AreaChart,
//     Area,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     ResponsiveContainer,
// } from "recharts";

// import "../../styles/chart.css";
// import SelectDropdown from "./SelectDropdown";

// const ReusableChart = ({ data, title, filters }) => {
//     const [selectedMonth, setSelectedMonth] = useState(filters.months[0].value);
//     const [selectedYear, setSelectedYear] = useState(filters.years[0].value);

//     // Ensure all months are shown
//     const monthsOrder = [
//         "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
//     ];

//     const aggregatedData = useMemo(() => {
//         const map = {};
//         data.forEach(item => {
//             map[item.month] = (map[item.month] || 0) + item.totalDealers;
//         });
//         return monthsOrder.map(month => ({
//             month,
//             Logins: map[month] || 0,
//         }));
//     }, [data]);

//     // Custom tooltip
//     const CustomTooltip = ({ active, payload, label }) => {
//         if (active && payload && payload.length) {
//             return (
//                 <div className="custom-tooltip" style={{ borderColor: "#3B82F6" }}>
//                     <p className="tooltip-label">{label}</p>
//                     {payload.map((entry, index) => (
//                         <p key={index} className="tooltip-item">
//                             <span
//                                 className="tooltip-color"
//                                 style={{ backgroundColor: "#3B82F6" }}
//                             ></span>
//                             <span className="tooltip-name">{entry.name}: </span>
//                             <span className="tooltip-value">{entry.value}</span>
//                         </p>
//                     ))}
//                 </div>
//             );
//         }
//         return null;
//     };

//     return (
//         <div className="chart-container">
//             {/* Header */}
//             <div className="chart-header">
//                 <h2 className="chart-title">{title}</h2>
//                 <div className="chart-filters">

//                     <SelectDropdown
//                         value={selectedMonth}
//                         onChange={setSelectedMonth}
//                         options={filters.months}
//                     />

//                     <SelectDropdown
//                         value={selectedYear}
//                         onChange={setSelectedYear}
//                         options={filters.years}
//                     />
//                 </div>

//             </div>

//             {/* Chart */}
//             <div className="chart-wrapper">
//                 <ResponsiveContainer width="100%" height={300}>
//                     <AreaChart
//                         data={aggregatedData}
//                         margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
//                     >
//                         {/* Gradient */}
//                         <defs>
//                             <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
//                                 <stop offset="0%" stopColor="#2563EB" stopOpacity={0.25} />
//                                 <stop offset="100%" stopColor="#2563EB" stopOpacity={0} />
//                             </linearGradient>
//                         </defs>

//                         {/* Grid */}
//                         <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />

//                         {/* X Axis */}
//                         <XAxis
//                             dataKey="month"
//                             tick={{ fill: "#6B7280", fontSize: 12, fontFamily: "Alata, sans-serif", }}
//                         />

//                         {/* Y Axis */}
//                         <YAxis
//                             domain={[0, 100]}
//                             tick={{ fill: "#6B7280", fontSize: 12, fontFamily: "Alata, sans-serif", }}
//                         />

//                         {/* Tooltip */}
//                         <Tooltip content={<CustomTooltip />} cursor={false} />

//                         {/* Area + Line */}
//                         <Area
//                             type="monotone"
//                             dataKey="Logins"
//                             stroke="#2563EB"          // 🔵 Dark blue line
//                             strokeWidth={2}
//                             fill="url(#blueGradient)" // 🔹 Light blue inside
//                             dot={{ r: 4, fill: "#2563EB" }}
//                             activeDot={{ r: 6 }}
//                         />
//                     </AreaChart>
//                 </ResponsiveContainer>

//             </div>
//         </div>
//     );
// };

// export default ReusableChart;

// src/components/ReusableChart.jsximport React, { useState, useMemo } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "../../styles/chart.css";
import SelectDropdown from "./SelectDropdown";
import { useMemo, useState } from "react";

const ReusableChart = ({
  title,
  filters,
  rawData,
  selectedMonth,
  selectedYear,
  setSelectedMonth,
  setSelectedYear,
}) => {
  // Custom tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{ borderColor: "#3B82F6" }}>
          <p className="tooltip-label">
            {selectedMonth ? `Day ${label}` : label}
          </p>
          {payload.map((entry, index) => (
            <p key={index} className="tooltip-item">
              <span
                className="tooltip-color"
                style={{ backgroundColor: "#2563EB" }}
              ></span>
              <span className="tooltip-name">{entry.name}: </span>
              <span className="tooltip-value">{entry.value}</span>
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h2 className="chart-title">{title}</h2>
        <div className="chart-filters">
          <SelectDropdown
            value={selectedMonth}
            onChange={setSelectedMonth}
            options={filters.months}
          />
          <SelectDropdown
            value={selectedYear}
            onChange={setSelectedYear}
            options={filters.years}
          />
        </div>
      </div>

      <div className="chart-wrapper">
        {rawData.length === 0 ? (
          <p
            style={{
              textAlign: "center",
              padding: "50px 0",
              color: "#6B7280",
              width: "100%",
            }}
          >
            No data available for the selected filters
          </p>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart
              data={rawData}
              margin={{ top: 20, right: 30, left: 0, bottom: 10 }}
            >
              <defs>
                <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#2563EB" stopOpacity={0.25} />
                  <stop offset="100%" stopColor="#2563EB" stopOpacity={0} />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis
                dataKey="x"
                tick={{
                  fill: "#6B7280",
                  fontSize: 12,
                  fontFamily: "Alata, sans-serif",
                }}
                label={{
                  value: selectedMonth ? "Day" : "Month",
                  position: "insideBottomRight",
                  offset: -5,
                }}
              />
              <YAxis
                tick={{
                  fill: "#6B7280",
                  fontSize: 12,
                  fontFamily: "Alata, sans-serif",
                }}
              />
              <Tooltip content={<CustomTooltip />} cursor={false} />
              <Area
                type="monotone"
                dataKey="count"
                stroke="#2563EB"
                strokeWidth={2}
                fill="url(#blueGradient)"
                dot={{ r: 4, fill: "#2563EB" }}
                activeDot={{ r: 6 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default ReusableChart;
